"use client";

import { type FormEvent, useState } from "react";
import { apiRequest } from "@/lib/apiClient";

export function ContactForm() {
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState<string | null>(null);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();

    const form = event.currentTarget;
    const formData = new FormData(form);

    setSubmitting(true);
    setSubmitError(null);

    try {
      await apiRequest<void>("/api/contact", {
        method: "POST",
        json: {
          name: String(formData.get("name") ?? ""),
          company: String(formData.get("company") ?? ""),
          contact: String(formData.get("contact") ?? ""),
          message: String(formData.get("message") ?? ""),
        },
      });

      form.reset();
      setSent(true);
    } catch {
      setSubmitError(
        "Не удалось отправить заявку. Попробуйте ещё раз или напишите нам на почту.",
      );
    } finally {
      setSubmitting(false);
    }
  }

  if (sent) {
    return (
      <div className="success-message">
        <span>✓</span>
        <h3>Заявка принята</h3>
        <p>Спасибо! Мы получили сообщение и скоро свяжемся с вами.</p>
        <button
          type="button"
          onClick={() => {
            setSent(false);
            setSubmitError(null);
          }}
        >
          Отправить ещё одну
        </button>
      </div>
    );
  }

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <label>
        <span>
          Ваше имя{" "}
          <b className="required-star" aria-hidden="true">
            *
          </b>
        </span>
        <input
          name="name"
          placeholder="Как к вам обращаться?"
          maxLength={120}
          required
        />
      </label>
      <label>
        <span>Компания</span>
        <input
          name="company"
          placeholder="Название компании"
          maxLength={160}
        />
      </label>
      <label className="full">
        <span>
          Как связаться{" "}
          <b className="required-star" aria-hidden="true">
            *
          </b>
        </span>
        <input
          name="contact"
          placeholder="Телефон, Telegram или email"
          maxLength={255}
          required
        />
      </label>
      <label className="full">
        <span>
          О проекте{" "}
          <b className="required-star" aria-hidden="true">
            *
          </b>
        </span>
        <textarea
          name="message"
          placeholder="Что нужно разработать?"
          rows={3}
          maxLength={5000}
          required
        />
      </label>
      <div className="form-footer full">
        {submitError && (
          <p className="form-error" role="alert">
            {submitError}
          </p>
        )}
        <button
          className="button button-dark"
          type="submit"
          disabled={submitting}
        >
          {submitting ? "Отправляем…" : "Отправить заявку"}{" "}
          <span aria-hidden="true">↗</span>
        </button>
      </div>
    </form>
  );
}
